import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { dateToISOStringPreprocessor } from '../../../utils/date-to-iso-string-preprocessor';
import { ignoreData } from '../../../utils/ignore-data';
import { parseRequestSchema } from '../../../utils/parse-request-schema';
import { authwsEnvironment } from '../authws-environment';
import { accountProductRelationshipSchema } from '../schemas/account-product-relationship.schema';

const requestSchema = accountProductRelationshipSchema
  .omit({
    manageOwnAPIKeys: true,
    phone: true,
  })
  .partial()
  .required({
    accountState: true,
  });

/**
 * Creates a relationship between a Trimble Maps product and an account
 * @param product Trimble Maps product name
 * @param accountId Id of the Account
 * @param request Account Product Relationship
 */
export function postProductsProductAccounts(
  this: unknown,
  product: string,
  accountId: number,
  request: z.infer<typeof requestSchema>
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).productsUrl}/${encodeURIComponent(
        product
      )}/accounts/${encodeURIComponent(accountId)}`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: parseRequestSchema(
          requestSchema.extend({
            expirationDate: dateToISOStringPreprocessor().nullable().optional(),
          }),
          request
        ),
      }
    )
  ).pipe(ignoreData());
}
